export const colors = {
  // DSM pallete
  backgroundAlt: '#1D1D1D',
  primary: {
    DEFAULT: '#005CBC',
    50: '#E6EFF8',
    100: '#CCDEF2',
    150: '#B3CEEB',
    200: '#99BEE4',
    300: '#669DD7',
    350: '#66A5E7',
    400: '#337DC9',
    500: '#005CBC',
    600: '#004A96',
    700: '#003771',
    800: '#00254B',
    850: '#001C38',
    900: '#001226',
    950: '#000913',
  },
  secondary: {
    DEFAULT: '#117D9F',
    50: '#E7F2F5',
    100: '#CFE5EC',
    150: '#B8D8E2',
    200: '#A0CBD9',
    300: '#70B1C5',
    400: '#4197B2',
    500: '#117D9F',
    600: '#0E647F',
    700: '#0A4B5F',
    800: '#073240',
    850: '#052630',
    900: '#031920',
    950: '#020D10',
  },
  tertiary: {
    DEFAULT: '#B05788',
    50: '#F7EEF3',
    100: '#EFDDE7',
    150: '#E7CDDB',
    200: '#DFBCCF',
    300: '#D09AB8',
    400: '#C079A0',
    500: '#B05788',
    600: '#8D466D',
    700: '#6A3452',
    800: '#462336',
    850: '#351A29',
    900: '#23111B',
    950: '#12090E',
  },
  auxiliary: {
    DEFAULT: '#0096D1',
    50: '#E6F5FA',
    100: '#CCEAF6',
    150: '#B3E0F1',
    200: '#99D5ED',
    300: '#66C0E3',
    400: '#33ABDA',
    500: '#0096D1',
    600: '#0078A7',
    700: '#005A7D',
    800: '#003C54',
    850: '#002D3F',
    900: '#001E2A',
    950: '#000F15',
  },
  green: {
    DEFAULT: '#008553',
    50: '#E6F3EE',
    100: '#CCE7DD',
    150: '#B3DACB',
    200: '#99CEBA',
    300: '#66B698',
    400: '#339D75',
    500: '#008553',
    600: '#006A42',
    700: '#005032',
    800: '#003521',
    850: '#002819',
    900: '#001B11',
    950: '#000D08',
  },
  red: {
    DEFAULT: '#D40020',
    50: '#FBE6E9',
    100: '#F6CCD2',
    150: '#F2B3BC',
    200: '#EE99A6',
    300: '#E56679',
    350: '#E46666',
    400: '#DD334D',
    500: '#D40020',
    600: '#AA001A',
    700: '#7F0013',
    800: '#55000D',
    850: '#40000A',
    900: '#2A0006',
    950: '#150003',
  },
  blue: {
    DEFAULT: '#D7E5F8',
    50: '#FBFCFE',
    100: '#F7FAFE',
    150: '#F3F7FD',
    200: '#EFF5FC',
    300: '#E7EFFB',
    400: '#DFEAF9',
    500: '#D7E5F8',
    600: '#B2CAEA',
    700: '#8DAFDC',
    800: '#6993CD',
    850: '#5686C6',
    900: '#4478BF',
    950: '#316BB8',
  },
  cyan: {
    DEFAULT: '#AAD2E2',
    50: '#F7FBFC',
    100: '#EEF6F9',
    150: '#E6F2F6',
    200: '#DDEDF3',
    300: '#CCE4EE',
    400: '#BBDBE8',
    500: '#AAD2E2',
    600: '#88A8B5',
    700: '#667E88',
    800: '#44545A',
    850: '#333F44',
    900: '#222A2D',
    950: '#111517',
  },
  yellow: {
    DEFAULT: '#FFBF1C',
    50: '#FFF9E8',
    100: '#FFF2D2',
    150: '#FFECBB',
    200: '#FFE5A4',
    300: '#FFD977',
    400: '#FFCC49',
    500: '#FFBF1C',
    600: '#CC9916',
    700: '#997311',
    800: '#664C0B',
    850: '#4D3908',
    900: '#332606',
    950: '#1A1303',
  },
  gray: {
    DEFAULT: '#616161',
    50: '#EFEFEF',
    100: '#DFDFDF',
    150: '#D0D0D0',
    200: '#C0C0C0',
    300: '#A0A0A0',
    400: '#818181',
    500: '#616161',
    600: '#4E4E4E',
    700: '#3A3A3A',
    800: '#363636',
    850: '#1D1D1D',
    900: '#131313',
    950: '#0A0A0A',
  },

  // DSM tokens
  background: '#F3F7FD',
  border: {
    DEFAULT: '#C0C0C0',
    hover: '#818181',
    gray: '#E3E3E3',
  },
  button: {
    primary: {
      DEFAULT: '#005CBC',
      hover: '#004A96',
    },
    secondary: {
      DEFAULT: '#117D9F',
      hover: '#0E647F',
      active: '#70B1C5',
    },
    disabled: {
      background: '#D0D0D0',
      text: '#A0A0A0',
    },
    icon: {
      DEFAULT: '#F7FAFE',
      hover: '#EFF5FC',
      active: '#7DB3FC',
      disabled: '#838383',
    },
    red: {
      DEFAULT: '#AA001A',
      hover: '#bc1919',
    },
  },
  layer: {
    '01': {
      DEFAULT: '#FBFCFE',
      hover: '#DFEAF9',
      inverted: '#272727',
    },
    '02': '#EFF5FC',
    '03': '#B2CAEA',
    disabled: '#D0D0D0',
  },
  link: {
    DEFAULT: '#005CBC',
    hover: '#004A96',
    disabled: '#A0A0A0',
  },
  text: {
    primary: '#3A3A3A',
    secondary: '#616161',
    black: '#000000',
    white: '#FFFFFF',
    disabled: '#A0A0A0',
  },
  label: {
    border: '#D7E5F8',
  },
  support: {
    success: {
      primary: '#008553',
      secondary: '#CCE7DD',
    },
    error: {
      primary: '#D40020',
      secondary: '#FBE6E9',
    },
    info: {
      primary: '#0078A7',
      secondary: '#EEF6F9',
    },
    warning: {
      primary: '#FFBF1C',
    },
  },
  icon: {
    DEFAULT: '#3A3A3A',
  },
  status: {
    NEW: '#FFECBB',
    DRAFT: '#FFECBB',
    SAVED: '#FFECBB',
    PAUSED: '#DFDFDF',
    PUBLISHED: '#AAD2E2',
    COMPLETED: '#B3DACB',
  },
}
